import { FC } from "react";
import { useRouter } from "expo-router";
import { useSetAtom } from "jotai/react";
import { MenuIcon } from "lucide-react-native";

import { VnBox } from "@/components/VnBox";
import { VnButton } from "@/components/VnButton/VnButton";
import {
  VnDropdownMenu,
  VnDropdownMenuContent,
  VnDropdownMenuGroup,
  VnDropdownMenuItem,
  VnDropdownMenuTrigger,
} from "@/components/VnDropdownMenu";
import { VnIcon } from "@/components/VnIcon";
import { VnText } from "@/components/VnText/VnText";
import { useSignOutMutation } from "@/data/mutations/authMutations";
import { isManualLogoutAtom } from "@/stores/atoms";

import { LanguageSelector } from "./LanguageSelector";

type HeaderMenuDropdownPropsType = {
  className?: string;
};

export const HeaderMenuDropdown: FC<HeaderMenuDropdownPropsType> = ({
  className,
}) => {
  const { mutate: signOut } = useSignOutMutation();
  const setIsManualLogout = useSetAtom(isManualLogoutAtom);
  const router = useRouter();

  return (
    <VnDropdownMenu className={className}>
      <VnDropdownMenuTrigger asChild>
        <VnButton variant="outline" className="rounded-md">
          <VnIcon as={MenuIcon} size={24} className="text-sidebar-foreground" />
        </VnButton>
      </VnDropdownMenuTrigger>
      <VnDropdownMenuContent className="mr-5 mt-2 gap-2">
        <VnDropdownMenuGroup className="gap-1">
          <VnDropdownMenuItem
            onPress={() => router.replace("/(authed)")}
            i18nKey="native:appMenu.household"
          />
          <VnDropdownMenuItem
            onPress={() => router.push("/(authed)/account")}
            i18nKey="native:appMenu.account"
          />
        </VnDropdownMenuGroup>
        <VnDropdownMenuGroup className="gap-1">
          <VnDropdownMenuItem>
            <VnBox className="w-full">
              <LanguageSelector>
                <VnText i18nKey="native:appMenu.language" />
              </LanguageSelector>
            </VnBox>
          </VnDropdownMenuItem>
          <VnDropdownMenuItem>
            <VnText
              i18nKey="native:appMenu.logout"
              onPress={() => {
                setIsManualLogout(true);
                signOut();
              }}
              className="w-full"
            />
          </VnDropdownMenuItem>
        </VnDropdownMenuGroup>
      </VnDropdownMenuContent>
    </VnDropdownMenu>
  );
};
